/*
 * File: DownloadIssuedForm.ts
 * Author: Austin Robinson
 * Date Created: 9/15/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';

export type DownloadIssuedFormParams = {
    id: string;
};

export type PDF = Blob;

async function downloadIssuedForm(params: DownloadIssuedFormParams) {
    if (!params.id) {
        return null
    }

    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/forms/issued/${params.id}`, {
        headers: {
            Accept: 'application/pdf'
        },
        responseType: 'blob',
    });

    // extract the filename from the Content-Disposition header
    const fileName = result.headers['content-disposition'].match(/filename="([^"]+)"/)[1];

    // create a link for the pdf blob
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement('a');
    link.href = url;

    // set the filename
    if (fileName) {
        link.setAttribute('download', fileName);
    } else {
        link.setAttribute('download', 'form.pdf');
    }

    // append element and click link
    document.body.appendChild(link);
    link.click();

    // remove temporary link from body
    document.body.removeChild(link);

    // return the blob
    return result.data as PDF;
}

// const useGetIssuedForm = createQuery<PDF[], GetIssuedForm, Error>({
//     queryKey: ['issued_form',
//     fetcher: (variables) => getIssuedForm(variables),
// enabled: (data) => !data,
// });

export { downloadIssuedForm };


